import React from 'react';
import classNames from 'classnames';

import css from './ListingPage.module.css';

const FieldMaybe = props => {
  const { contentClassName, heading, content } = props;

  return content ? (
    <div className={css.field}>
      <div className={css.fieldHeading}>{heading}</div>
      <p className={classNames(css.fieldContent, contentClassName)}>{content}</p>
    </div>
  ) : null;
};

export default FieldMaybe;
